export interface Role {
  businessRole: string;
  entityIds: string[];
  id: string;
}

export enum RoleTypeEnum {
  DR_ADMIN = 'DR_ADMIN',
  CUSTOMER_OFFER_USER = 'CUSTOMER_OFFER_USER',
  COM_IGNORE_OFFER_RULES = 'COM_IGNORE_OFFER_RULES'
}

export enum BusinessRole {
  PerformanceAdmin = 'PERFORMANCE_ADMIN',
  CustomerOfferUser = 'CUSTOMER_OFFER_USER',
  IrishMarketUser = 'IRISH_MARKET_USER',
  DrGeneralUser = 'DR_GENERAL_USER'
}

export type UserRolesEventDetail = { userRoles?: Role[] };
